import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import { abodeTheme } from './theme';

import App from './App.vue';
import { router } from './router';
import { onUnauthorized } from './api/client';
import { useAuthStore } from './stores/auth';
import { useThemeStore } from './stores/theme';

import 'primeicons/primeicons.css';
import './assets/main.css';

const app = createApp(App);

app.use(createPinia());
// Initialize theme store so the dark-mode class is set before render,
// avoiding a flash of light content when the user's preference is dark.
useThemeStore();
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: abodeTheme,
    options: {
      darkModeSelector: '.dark-mode',
    },
  },
  ripple: true,
});
app.use(ToastService);
app.use(ConfirmationService);

// When the API client reports a 401, clear the session cache and bounce
// the user to the login page.
onUnauthorized(() => {
  const auth = useAuthStore();
  auth.reset();
  if (router.currentRoute.value.name !== 'login') {
    router.push({
      name: 'login',
      query: { redirect: router.currentRoute.value.fullPath },
    });
  }
});

app.mount('#app');
